import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../material/material.module';

import { ArrayBoxComponent } from './array-box.component';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule
  ],
  exports: [ArrayBoxComponent],
  declarations: [ArrayBoxComponent]
})
export class ArrayBoxModule { }



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/array-box/array-box.module.ts